import Description from './description.vue'

export default Description;